import { render, staticRenderFns } from "./HohEntryFormEntriesPage.vue?vue&type=template&id=1a27faf4&"
import script from "./HohEntryFormEntriesPage.vue?vue&type=script&lang=js&"
export * from "./HohEntryFormEntriesPage.vue?vue&type=script&lang=js&"
import style0 from "./HohEntryFormEntriesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDataTable,VDivider,VIcon,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a27faf4')) {
      api.createRecord('1a27faf4', component.options)
    } else {
      api.reload('1a27faf4', component.options)
    }
    module.hot.accept("./HohEntryFormEntriesPage.vue?vue&type=template&id=1a27faf4&", function () {
      api.rerender('1a27faf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HohEntryFormPage/HohEntryFormEntriesPage/HohEntryFormEntriesPage.vue"
export default component.exports